import React from 'react'
import type { ChangeEvent } from 'react'
import {
    Row,
    Col,
    Card,
    CardBody,
    CustomInput,
} from 'reactstrap'
import { Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartData,
    ChartOptions,
} from 'chart.js'
import { rgbaColor } from '../../../components/shared/utils'
import { getMonthsRange } from '../../../components/shared/months-range'
import { setDeviceOilHistoryTimeRangeAction } from '../../../reducers/actions/device-oil-history'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
)

interface OilHistoryItem {
    formattedCreatedAt: string
    oilLevelPercentage: number
}

interface OilLevelHistoryChartProps {
    deviceOilHistory: OilHistoryItem[]
    oilHistoryFrom: string | number
    oilHistoryTo: string | number
}

/**
 * Render device oil level chart
 */
const OilLevelHistoryChart = ({
    deviceOilHistory,
    oilHistoryFrom,
    oilHistoryTo,
}: OilLevelHistoryChartProps) => {
    const selectedMonth = `${oilHistoryFrom}-${oilHistoryTo}`

    const data: ChartData<'line'> = {
        labels: deviceOilHistory.map(oilHistory => oilHistory.formattedCreatedAt),
        datasets: [
            {
                label: '',
                borderWidth: 1,
                data: deviceOilHistory.map(oilHistory => oilHistory.oilLevelPercentage),
                backgroundColor: rgbaColor('#FFD156'),
                borderColor: '#FFD156',
            },
        ],
    }

    const options: ChartOptions<'line'> = {
        plugins: {
            legend: { display: false },
            tooltip: {
                mode: 'index',
                intersect: false,
                padding: 12,
                displayColors: false,
            },
        },
        hover: { mode: 'index', intersect: false },
    }

    return (
        <Card className='mb-3 w-100 shadow-none'>
            <CardBody className='rounded-soft w-100'>
                <Row className='text-white align-items-center no-gutters'>
                    <Col />
                    <Col xs='auto' className='d-none d-sm-block'>
                        <CustomInput
                            id='ddd'
                            type='select'
                            bsSize='sm'
                            className='mb-3 shadow'
                            value={selectedMonth}
                            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                setDeviceOilHistoryTimeRangeAction(
                                    event.target.value.split('-')[0],
                                    event.target.value.split('-')[1],
                                )
                            }
                        >
                            {getMonthsRange().map(month => (
                                <option
                                    key={month.month}
                                    value={`${month.start}-${month.end}`}
                                >
                                    {month.month}
                                </option>
                            ))}
                        </CustomInput>
                    </Col>
                </Row>
                <Line
                    data={data}
                    options={options}
                    width={100}
                    height={50}
                />
            </CardBody>
        </Card>
    )
}

export default OilLevelHistoryChart
